var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 110.544C25 109.803 25 109.213 25 108.606C25 90.113 25 71.6202 25 53.1274C25 42.7768 31.7897 36 42.169 36C73.5777 36 104.986 36 136.412 36C146.774 36 153.564 42.7768 153.581 53.1105C153.581 64.5568 153.581 75.9863 153.581 87.4326V89.3207C152.531 89.3207 151.549 89.287 150.567 89.3207C146.554 89.4555 142.474 89.1353 138.562 89.8264C129.03 91.4953 122.037 99.7893 121.461 109.432C121.444 109.769 121.427 110.089 121.394 110.528H25V110.544Z",
    fill: "url(#paint0_linear_106_321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.343 121.435V142.658H108.898C110.608 146.165 112.166 149.452 113.808 152.705C113.977 153.026 114.57 153.228 114.993 153.312C115.637 153.43 116.331 153.312 116.991 153.43C119.683 153.919 121.597 156.414 121.394 159.078C121.19 161.691 119.023 163.815 116.348 163.983C115.349 164.051 114.333 164 113.334 164C96.5544 164 79.7579 164 62.9783 164C58.7961 164 56.0193 160.325 57.5262 156.751C58.4575 154.56 60.1846 153.262 62.6058 153.397C64.1805 153.498 64.8578 152.857 65.4673 151.559C66.8219 148.66 68.3119 145.811 69.8696 142.692H67.8717C59.1686 142.692 50.4656 142.692 41.7626 142.692C31.976 142.641 25.0339 135.747 25 126.003C25 124.52 25 123.019 25 121.435H121.343Z",
    fill: "url(#paint1_linear_106_321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.983 131.903C174.983 138.849 174.983 145.794 174.983 152.739C174.983 159.415 170.428 163.967 163.757 163.983C156.951 164 150.144 164 143.337 163.983C136.751 163.967 132.145 159.415 132.145 152.891C132.128 138.95 132.128 125.009 132.145 111.067C132.145 104.628 136.751 100.026 143.202 100.009C150.059 99.9919 156.934 99.9919 163.791 100.009C170.378 100.009 174.966 104.56 175 111.101C175.017 118.046 175 124.992 175 131.937L174.983 131.903ZM148.197 110.73C148.197 112.652 148.146 114.371 148.197 116.074C148.281 118.839 150.415 121.064 153.09 121.283C155.715 121.502 158.339 119.749 158.711 117.102C159.016 115.012 158.779 112.837 158.779 110.713H148.197V110.73Z",
    fill: "url(#paint2_linear_106_321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_321",
    x1: 89.2906,
    y1: 36,
    x2: 89.2906,
    y2: 110.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_321",
    x1: 73.2041,
    y1: 121.435,
    x2: 73.2041,
    y2: 164.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_321",
    x1: 153.57,
    y1: 99.9961,
    x2: 153.57,
    y2: 163.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 128,
    fill: "white",
    transform: "translate(25 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPlatform);
export default __webpack_public_path__ + "static/media/Cross-Platform.6d3e94baff08d8e16afd423441b48154.svg";
export { ForwardRef as ReactComponent };